import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltCommentsSidebarV2CloseButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-close-button-v2-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2CloseButton;
